import type { AppPlugin } from "./definitions"
import { registerPlugin } from "@capacitor/core"

const Recaptcha = registerPlugin<AppPlugin>("Recaptcha")

export * from "./definitions"
export { Recaptcha }
